<template>
  <div id="app">
    <DialogProvider :ModalComponent="LnDialogVue">
      <!-- <keep-alive> -->
        <router-view />
      <!-- </keep-alive> -->
    </DialogProvider>
  </div>
</template>

<script>
import { DialogProvider } from '@/features/dialog';
import LnDialogVue from '@/features/dialog/LnDialog.vue';
import { keepAliveInclude } from './hooks/useKeepAlive';

export default {
  name: 'app',
  components: {
    DialogProvider
  },
  setup() {
    return {
      LnDialogVue,
      keepAliveInclude
    };
  }
};
</script>

<style lang="scss">
.part-title {
  font-family: SourceHanSansCN;
  font-weight: 800;
  font-size: 0.3rem;
  color: #000000;
  display: flex;
  align-items: center;
  padding: 0.2rem 0;
  &::before {
    content: '';
    display: inline-block;
    width: 0.08rem;
    height: 0.45rem;
    background: #ffc100;
    margin-right: 0.15rem;
  }
}
</style>
